import React, { useContext } from 'react';
import TableRow from '@material-ui/core/TableRow';
import MaterialTableHead from '@material-ui/core/TableHead';
import ReportSummaryContext from '@/modules/reports/contexts/ReportSummaryContext';
import TableCellOrder from '@/modules/common/components/TableCellOrder';
import CellPrimary from './CellPrimary';

const TableHead = () => {
    const reportSummaryContext = useContext(ReportSummaryContext);

    return (
        <MaterialTableHead>
            <TableRow>
                <CellPrimary/>
                <TableCellOrder className="sum"
                                orderName="sum" ordering={reportSummaryContext.ordering}
                                onClick={reportSummaryContext.handleClickOrder}
                >
                    Sum
                </TableCellOrder>
            </TableRow>
        </MaterialTableHead>
    );
};

export default TableHead;
